(function($) {
  $(document).ready(() => {
    setTimeout(() => {
      if ($("#block-gototopctablock").length) {
        fixGoToTopBlock();
      }

      if ($(".signup-onespan-form").length) {
        fixSignupFormBlock();
      }

      if (!$(".signup-onespan-form").length) {
        repositionRelatedPosts();
      }

      if ($(".promo").length && $(window).width() > 991) {
        bindPromoEvents();
      }
    }, 10);
  });

  // Show slider ad after scrolling 50% of blog post
  $(window).scroll(
    Drupal.debounce(() => {
      if (
        $(window).scrollTop() >=
        ($(document).height() - $(window).height()) * 0.5
      )
        $(".slider-ad").addClass("slider-show");
      else $(".slider-ad").stop(true);
    })
  );

  // click function for close button
  $(".slider-ad .close").bind("click", function() {
    $(this)
      .parent()
      .remove();
  });

  // If the user is on desktop, make the whole promo clickable.
  const bindPromoEvents = () => {
    $(".promo").each(function() {
      const $promo = $(this);

      $promo.on("click", e => {
        e.stopPropagation();
        $promo.find("a[href]")[0].click();
      });
    });
  };

  // Toggle slider ad when clicking on OneSignal notification bell (on blog pages)
  function toggleSliderAd() {
    $(".slider-ad").toggleClass("slider-hide slider-show");
  }

  setTimeout(() => {
    // toggle show/hide classes on click of bell icon
    $("#onesignal-bell-launcher").on("click", () => {
      toggleSliderAd();
    });

    // toggle show/hide classes on click of subscribe button in bell icon tooltip
    $(".onesignal-bell-launcher-dialog-body #subscribe-button").on(
      "click",
      () => {
        toggleSliderAd();
      }
    );

    // toggle show/hide classes on click of unsubscribe button in bell icon tooltip
    $(".onesignal-bell-launcher-dialog-body #unsubscribe-button").on(
      "click",
      () => {
        toggleSliderAd();
      }
    );
  }, 5000);

  // Fix some layout issues with the sign up form block.
  function fixSignupFormBlock() {
    const $signupForm = $(".signup-onespan-form");

    // Move the block out of the aside before the articles (mobile).
    const $blogView = $(
      ".view-blog, .view-blog2, .view-blog-by-category, .view-taxonomy-term"
    );
    if ($blogView.length && $(window).width() <= 991) {
      $blogView.prepend($signupForm);
    }
  }

  // If the signup form is disabled, position the related posts section where the signup form would be
  function repositionRelatedPosts() {
    const $relatedPostsBlock = $(
      "section#block-views-block-related-blog-posts-block-1"
    );

    const $postFull = $(".post-full");
    if ($postFull.length && $(window).width() > 992) {
      // $relatedPostsBlock.css("margin-top", `${getMarginTop($postFull)}px`);
    }
  }

  // Trigger the scroll animation on click.
  function fixGoToTopBlock() {
    $("aside").addClass("gototop-cta-wrapper");
    $(".gototop-cta-btn").on("click", e => {
      e.preventDefault();
      $("html").animate({ scrollTop: 0 }, "fast");
    });
  }
})(jQuery);
